
<div class="w-100">
  <label v-if="label" class="mb-0 c-label" :class="labelClass">{{ label }}</label>
  <div class="c-select" :class="disabled ? 'bg-light-grey' : (readonly ? 'white' : '')" @blur="open = false">
    <div ref="select" class="selected" :class="open ? boxClass + ' open': boxClass" @click="disabled || readonly ? '' : toggleOpen()">
      <div v-if="typeof selected === 'object'">
        <span v-if="placeholder && !selected">{{ placeholder }}</span>
        <span v-if="defaultValue && defaultValue !== selected[itemText]">{{ defaultValue }}</span>
        <span v-else>
          <img v-if="selected.type && selected.type == 'View::List'" class="mr-2" src="../../assets/images/icons/c_list_green.svg">
          <img v-if="selected.type && selected.type == 'View::Board'" class="mr-2" src="../../assets/images/icons/c_board_orange.svg">
          <img v-if="selected.type && selected.type == 'View::Calendar'" class="mr-2" src="../../assets/images/icons/c_calendar_purple.svg">
          <v-icon v-if="selected.type && selected.type == 'Analytic::Finance'" class="mr-2 mb-1" dense color="rgba(51, 51, 51, 1)">mdi-database-outline</v-icon>
          <v-icon v-if="selected.type && selected.type == 'Analytic::Case'" class="mr-2 mb-1" dense color="rgba(51, 51, 51, 1)">mdi-dresser-outline</v-icon>
          <v-icon v-if="selected.type && selected.type == 'Analytic::Task'" class="mr-2 mb-1" dense color="rgba(51, 51, 51, 1)">mdi-book-open-outline</v-icon>
          <v-icon v-if="selected.type && selected.type == 'Analytic::Invoice'" class="mr-2 mb-1" dense color="rgba(51, 51, 51, 1)">mdi-receipt</v-icon>
          <v-icon v-if="selected.type && selected.type == 'Analytic::Payment'" class="mr-2 mb-1" dense color="rgba(51, 51, 51, 1)">mdi-currency-usd</v-icon>
          {{ selected[itemText] }}
          <span v-if="itemDescription"> - {{ selected[itemDescription] }}</span>
        </span>
      </div>
      <div v-else>
        <span class="text-grey" v-if="placeholder && !selected">{{ placeholder }}</span>
        <span v-if="defaultValue && defaultValue !== selected">{{ defaultValue }}</span>
        <span v-else>{{ selected.replace(/_/g, ' ') }}</span>
      </div>
    </div>
    <div class="chevron" style="right: 10px;" :class="{ open: open }" @click="toggleOpen()"></div>
    <div class="c-items" style="max-height: 200px" :class="{ selectHide: !open, dropdownUp: isDropdownUp }">
      <div class="pl-0 pr-2" :style="i < options.length - 1 ? 'border-bottom: 1px solid #BDBDBD;' : ''" v-for="(option, i) of options" :key="i" @click="selectOption(option)">
        <CListItem :anotherAddsFunction="anotherAddsFunction" :itemDescription="itemDescription" :addsFunction="addsFunction" :itemText="itemText" :option="option" :itemClass="itemClass" :anotherAddsClass="anotherAddsClass"></CListItem>
      </div>
      <slot name="slot-card"></slot>
    </div>
  </div>
</div>
